import { Component, inject } from '@angular/core';
import { FIELD_EXTRA_DATA } from '@app/core/model/other/field-config';

@Component({
    templateUrl: './default-header.component.html',
    standalone: false
})
export class DefaultHeaderComponent {
  protected headerText = inject<{ headerText: string }>(FIELD_EXTRA_DATA).headerText;
}
